import React, { useEffect, useState } from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';

// Components
import { Tabs, Text } from '@beef/ui-kit';
import CtnCard from './components/CtnCard';
import { SectionWrapper } from '../SectionWrapper';

// Constant
import { toggleRoaming } from '../../store/expensesData/action';

// Styles
import styles from './styles.pcss';
import UpdateByDate from '../UpdateByDate';

const cx = classNames.bind(styles);

const tabsList = [
  {
    id: 'no_roaming',
    title: 'По России',
  },
  { id: 'roaming',
    title: 'Роуминг' },
];

const CtnBlock = () => {
  const { ctn, roaming, isExpensesFetching, incorrectPeriod } = useSelector(({ detalizationNew }) => ({
    ctn: detalizationNew.expenses.ctn,
    roaming: detalizationNew.expenses.roaming,
    isExpensesFetching: detalizationNew.expenses.isFetching,
    incorrectPeriod: detalizationNew.expenses.incorrectPeriod,
  }), shallowEqual);

  const dispatch = useDispatch();

  const [tabs, setTabs] = useState([]);
  const [selectedTab, setSelectedTab] = useState(0);

  useEffect(() => {
    const { ctnTabs } = ctn;

    if (ctnTabs?.length && ctnTabs[0]?.cost > 0) {
      setTabs(tabsList);
    }
  }, [ctn]);

  const handleChangeTab = (trafficVolume) => {
    setSelectedTab(trafficVolume);
  };

  useEffect(() => {
    dispatch(toggleRoaming(selectedTab === 'roaming'));
  }, [dispatch, selectedTab]);

  useEffect(() => {
    if (tabs.length >= 1) {
      setSelectedTab(tabs[0].id);
    }
  }, [tabs]);

  const ctnRoaming = roaming
    ? ctn?.ctnRoaming?.map((card) => <CtnCard {...card} key={card.id} />)
    : ctn?.ctnNoRoaming?.map((card) => <CtnCard {...card} key={card.id} />);

  return (
    <div className={cx('container')}>
      <div className={cx('heading-wrapper')}>
        <div className={cx('calendar-wrapper')}>
          <div className={cx('calendar')}>
            <UpdateByDate />
          </div>
        </div>
        <div className={cx('tabs')}>
          <Tabs
            onChange={(val) => handleChangeTab(val)}
            selectedTab={selectedTab}
            tabs={tabs}
            variant="secondary"
          />
        </div>
      </div>
      <SectionWrapper isFetching={isExpensesFetching} skeletonName="ctn">
        <div className={cx('card-wrapper', { 'card-wrapper__incorrect-period': incorrectPeriod })}>
          {!incorrectPeriod
            ? ctnRoaming
            : (
              <div className={cx('incorrect-period')}>
                <Text color="scarlet" size="size4-r">Выбран некорректный период</Text>
              </div>
            )}
        </div>
      </SectionWrapper>
    </div>
  );
};

CtnBlock.propTypes = {
  tabs: PropTypes.array,
  title: PropTypes.string,
  date: PropTypes.string,
};

export default CtnBlock;
